import { GroupType } from '@packages/types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import * as customizationSelectors from 'customizer/customization/selectors'
import * as questionPanelSelectors from 'customizer/questionPanel/selectors'
import useThemeSettings from 'customizer/theme/useThemeSettings'

import { stepsSelector } from '../../selectors'
import BulkOrderDrawer from './bulkOrder/BulkOrderDrawer'
import Step from './Step'
import Title from './Title'

import './QuestionPanel.scss'

const { isReadySelector } = customizationSelectors
const { currentStepSelector } = questionPanelSelectors

const QuestionPanel = () => {
  const questionStyle = useThemeSettings('question')

  const isReady = useSelector(isReadySelector)
  const steps = useSelector(stepsSelector)
  const selectedStep = useSelector(currentStepSelector)

  const { backgroundColor, borderColor, borderWidth } = useThemeSettings('questionPanel')

  useEffect(() => {
    if (selectedStep?.id) {
      document.getElementById(`step-${selectedStep.id}`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    }
  }, [selectedStep?.id])

  if (!isReady) return null

  return (
    <div className="question-panel-section">
      <div className="question-panel" style={{ backgroundColor, borderColor, borderWidth }}>
        <Title />
        <div className="question-panel__content">
          {steps.map(step => {
            if (step.type === GroupType.BulkOrder) {
              return <BulkOrderDrawer key={step.id} />
            }

            return (
              <Step
                step={step}
                key={step.id}
                questionStyle={{
                  color: questionStyle.questionFontColor,
                  fontSize: questionStyle.questionFontSize,
                  fontFamily: questionStyle.questionFontFamily?.fontFamily,
                }}
                descriptionStyle={{
                  color: questionStyle.descriptionFontColor,
                  fontSize: questionStyle.descriptionFontSize,
                  fontFamily: questionStyle.descriptionFontFamily?.fontFamily,
                }}
                headerStyle={{
                  borderBottomColor: questionStyle.dividerColor,
                  borderBottomWidth: questionStyle.dividerWidth,
                  paddingBottom: questionStyle.dividerWidth === '0px' ? '0' : '0.5rem',
                }}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default QuestionPanel
